
export default function UnderDevelopmentPage() {
  return (
    <>
    <div className="container d-flex justify-content-center align-items-center mt-5">
      <div
        className="card text-center shadow-lg p-4"
        style={{ maxWidth: "600px" }}
      >
        <div className="card-body">
          <h2 className="card-title text-warning">🚧 Under Development 🚧</h2>
          <p className="card-text text-muted">
            This module is currently under development and will be available
            soon. We appreciate your patience as we work to enhance your
            experience.
          </p>
          <hr />
          <h5 className="text-primary">🔄 Troubleshooting:</h5>
          <ul className="list-unstyled">
            <li>
              🔹 Press <b>Ctrl + Shift + R</b> to reload the page.
            </li>
            <li>🔹 If nothing happens, check back in a few days.</li>
            <li>🔹 For queries, contact our support team.</li>
          </ul>
          <p className="mt-3 text-success fw-bold">
            Thank you for your understanding! 😊
          </p>
        </div>
      </div>
    </div>
    </>
  );
}
